import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-available-dialog',
  templateUrl: './not-available-dialog.component.html',
  styleUrls: ['./not-available-dialog.component.scss']
})
export class NotAvailableDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NotAvailableDialogComponent>
  ) { }

  ngOnInit(): void { }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
